export function formDataToJson(formData: FormData): { [key: string]: any } {
  const jsonObject: { [key: string]: any } = {};

  formData.forEach((value, key) => {
    const isArrayField = key.endsWith("[]");
    const cleanKey = isArrayField ? key.slice(0, -2) : key;

    if (jsonObject[cleanKey]) {
      if (!Array.isArray(jsonObject[cleanKey])) {
        jsonObject[cleanKey] = [jsonObject[cleanKey]];
      }
      jsonObject[cleanKey].push(value);
    } else {
      jsonObject[cleanKey] = isArrayField ? [value] : value;
    }
  });

  return jsonObject;
}
